// extracted by mini-css-extract-plugin
export default {"container":"VBScrollContainer_container__EC4Oy","x":"VBScrollContainer_x__I9hmE","y":"VBScrollContainer_y__cLjlx"};